import { GetAllAreas } from './../../api/common.js'


const HomePage = {
    namespaced:true,
    state:{
        areas:[],
        currentAreaId:''
    },
    mutations:{
        getAreas(state, data){
            state.areas = data
        },
        setCurrentAreaId(state, data){
            state.currentAreaId = data
        }   
    },
    getters:{

    },
    actions:{
        // 通过项目id获取当前项目所有区域
        async actionsAllAreas(context){
            console.log(context);
            let res = await GetAllAreas({projectId:context.rootState.project.currentProject.projectId})
            let areas = res.data.data.areas
            context.commit('getAreas',areas)

        }
    }
}

export default HomePage